module.exports = __webpack_public_path__ + "media/dorobek/assets/images/icons/Achievement-contrast-f7caa100bbd8a7677145840694277665.svg";